/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Carriers API
 * Carrier-facing API for the carrier portal (carriers.freightsimple.com).  Authentication: a carrier opens a permanent signed login link, exchanges it for a session token, and presents that token as a bearer on every other call. `CarrierPortalAuthenticationFilter` validates the session and scopes each request to one carrier. Operations use `security: []` (no Micronaut JWT) — the filter is the authenticator, the same model the agents API uses.
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { CarrierIssueType } from "./CarrierIssueType";
import {
  CarrierIssueTypeFromJSON,
  CarrierIssueTypeFromJSONTyped,
  CarrierIssueTypeToJSON,
  CarrierIssueTypeToJSONTyped,
} from "./CarrierIssueType";

/**
 *
 * @export
 * @interface OperationalIssueResponseRequest
 */
export interface OperationalIssueResponseRequest {
  /**
   *
   * @type {string}
   * @memberof OperationalIssueResponseRequest
   */
  shipmentId: string;
  /**
   *
   * @type {CarrierIssueType}
   * @memberof OperationalIssueResponseRequest
   */
  issueType: CarrierIssueType;
  /**
   * Published to the customer's tracking immediately, as a tracking line
   * attributed to the carrier. Never mix internal remarks in here.
   * Truncated server-side at 2000 characters — this goes in front of a
   * customer and the sender is outside the company.
   *
   * @type {string}
   * @memberof OperationalIssueResponseRequest
   */
  customerVisibleNote?: string;
  /**
   * Seen only by FreightSimple.
   * @type {string}
   * @memberof OperationalIssueResponseRequest
   */
  internalNote?: string;
  /**
   * For book_pickup — the carrier's confirmation/pickup number.
   * @type {string}
   * @memberof OperationalIssueResponseRequest
   */
  pickupConfirmationNumber?: string;
  /**
   * ISO-8601 date. For book_pickup (the confirmed date) and
   * missed_pickup (the new date). Updates the shipment.
   *
   * @type {string}
   * @memberof OperationalIssueResponseRequest
   */
  pickupDate?: string;
  /**
   * ISO-8601 date. For expected_delivery_is_in_the_past and
   * missed_delivery. Updates the shipment.
   *
   * @type {string}
   * @memberof OperationalIssueResponseRequest
   */
  expectedDeliveryDate?: string;
  /**
   * Why the pickup or delivery was missed.
   * @type {string}
   * @memberof OperationalIssueResponseRequest
   */
  reason?: string;
  /**
   * For tracking_not_updated — where the freight is now.
   * @type {string}
   * @memberof OperationalIssueResponseRequest
   */
  currentStatus?: string;
  /**
   * For tracking_not_updated — city/terminal the freight is at.
   * @type {string}
   * @memberof OperationalIssueResponseRequest
   */
  currentLocation?: string;
  /**
   * For missing_freight. True closes the task; false records that the
   * search continues and leaves it open.
   *
   * @type {boolean}
   * @memberof OperationalIssueResponseRequest
   */
  freightFound?: boolean;
}

/**
 * Check if a given object implements the OperationalIssueResponseRequest interface.
 */
export function instanceOfOperationalIssueResponseRequest(
  value: object,
): value is OperationalIssueResponseRequest {
  if (!("shipmentId" in value) || value["shipmentId"] === undefined)
    return false;
  if (!("issueType" in value) || value["issueType"] === undefined) return false;
  return true;
}

export function OperationalIssueResponseRequestFromJSON(
  json: any,
): OperationalIssueResponseRequest {
  return OperationalIssueResponseRequestFromJSONTyped(json, false);
}

export function OperationalIssueResponseRequestFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): OperationalIssueResponseRequest {
  if (json == null) {
    return json;
  }
  return {
    shipmentId: json["shipmentId"],
    issueType: CarrierIssueTypeFromJSON(json["issueType"]),
    customerVisibleNote:
      json["customerVisibleNote"] == null
        ? undefined
        : json["customerVisibleNote"],
    internalNote:
      json["internalNote"] == null ? undefined : json["internalNote"],
    pickupConfirmationNumber:
      json["pickupConfirmationNumber"] == null
        ? undefined
        : json["pickupConfirmationNumber"],
    pickupDate: json["pickupDate"] == null ? undefined : json["pickupDate"],
    expectedDeliveryDate:
      json["expectedDeliveryDate"] == null
        ? undefined
        : json["expectedDeliveryDate"],
    reason: json["reason"] == null ? undefined : json["reason"],
    currentStatus:
      json["currentStatus"] == null ? undefined : json["currentStatus"],
    currentLocation:
      json["currentLocation"] == null ? undefined : json["currentLocation"],
    freightFound:
      json["freightFound"] == null ? undefined : json["freightFound"],
  };
}

export function OperationalIssueResponseRequestToJSON(
  json: any,
): OperationalIssueResponseRequest {
  return OperationalIssueResponseRequestToJSONTyped(json, false);
}

export function OperationalIssueResponseRequestToJSONTyped(
  value?: OperationalIssueResponseRequest | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    shipmentId: value["shipmentId"],
    issueType: CarrierIssueTypeToJSON(value["issueType"]),
    customerVisibleNote: value["customerVisibleNote"],
    internalNote: value["internalNote"],
    pickupConfirmationNumber: value["pickupConfirmationNumber"],
    pickupDate: value["pickupDate"],
    expectedDeliveryDate: value["expectedDeliveryDate"],
    reason: value["reason"],
    currentStatus: value["currentStatus"],
    currentLocation: value["currentLocation"],
    freightFound: value["freightFound"],
  };
}
